// Helpers for tolerating real-world export formats (Meta/Triple Whale exports
// arrive as .xlsx with a title row above the real header, e.g.
// "da881b-2.myshopify.com-Meta-2026-07-26" on row 1 and the actual
// Date/Ad Name/Ad Spend header on row 2).

// A row is the header row if it contains both of these (case-insensitive).
const HEADER_MARKERS = ["ad name", "ad spend"];

const isHeaderCells = (cells) => {
  const lowered = cells.map((c) => String(c ?? "").trim().toLowerCase());
  return HEADER_MARKERS.every((m) => lowered.includes(m));
};

// rows: array of arrays (e.g. XLSX sheet_to_json with {header: 1}).
// Returns the index of the header row within the first maxScan rows, or -1.
export const findHeaderRowIndex = (rows, maxScan = 10) => {
  const limit = Math.min(rows.length, maxScan);
  for (let i = 0; i < limit; i++) {
    if (isHeaderCells(rows[i] || [])) return i;
  }
  return -1;
};

// Convert array-of-arrays (header at headerIdx) into PapaParse-style row
// objects keyed by header name, values as strings. Skips fully empty rows.
export const rowsToObjects = (rows, headerIdx) => {
  const header = (rows[headerIdx] || []).map((h) => String(h ?? "").trim());
  return rows
    .slice(headerIdx + 1)
    .filter((r) => (r || []).some((c) => String(c ?? "").trim() !== ""))
    .map((r) => {
      const obj = {};
      header.forEach((h, i) => {
        if (!h) return;
        const v = r[i];
        obj[h] = v === undefined || v === null ? "" : String(v);
      });
      return obj;
    });
};

// For CSV text: if the real header line ("Ad Name" + "Ad Spend") appears
// within the first maxScan lines but is not line 0 (title junk above it),
// return the text starting from the header line. Otherwise return unchanged.
export const stripLeadingTitleLines = (text, maxScan = 10) => {
  const lines = text.split(/\r?\n/);
  const limit = Math.min(lines.length, maxScan);
  for (let i = 0; i < limit; i++) {
    const lowered = lines[i].toLowerCase();
    if (HEADER_MARKERS.every((m) => lowered.includes(m))) {
      return i === 0 ? text : lines.slice(i).join("\n");
    }
  }
  return text;
};
